(() => {
  if (customElements.get('sac-support-hours')) return;

  class SacSupportHours extends HTMLElement {
    minutes(value) {
      if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(value || '')) return null;
      const [hour, minute] = value.split(':').map(Number);
      return hour * 60 + minute;
    }

    isOpen(now = new Date()) {
      if (this.dataset.forceClosed === 'true') return false;
      try {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Los_Angeles', weekday: 'short',
          hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
        }).formatToParts(now);
        const time = Object.fromEntries(parts.map(part => [part.type, part.value]));
        if (time.weekday === 'Sun') return false;
        const prefix = time.weekday === 'Sat' ? 'saturday' : 'weekday';
        const start = this.minutes(this.dataset[`${prefix}Open`]);
        const end = this.minutes(this.dataset[`${prefix}Close`]);
        if (start === null || end === null || start >= end) return null;
        const current = Number(time.hour) * 60 + Number(time.minute);
        return current >= start && current < end;
      } catch {
        return null;
      }
    }

    formatTime(value) {
      const minutes = this.minutes(value);
      if (minutes === null) return value;
      const hour = Math.floor(minutes / 60);
      const minute = minutes % 60;
      return `${hour % 12 || 12}${minute ? `:${String(minute).padStart(2, '0')}` : ''} ${hour < 12 ? 'AM' : 'PM'}`;
    }

    connectedCallback() {
      this.disconnectedCallback();
      this.phone = this.querySelector('[data-support-call]');
      this.dialog = this.querySelector('dialog');
      this.closeButton = this.querySelector('[data-support-close]');
      if (!this.phone || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      for (const prefix of ['weekday', 'saturday']) {
        const hours = this.querySelector(`[data-${prefix}-hours]`);
        if (hours) hours.textContent = `${this.formatTime(this.dataset[`${prefix}Open`])}–${this.formatTime(this.dataset[`${prefix}Close`])}`;
      }
      this.onCall = event => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || this.isOpen() !== false) return;
        this.dialog.showModal();
        event.preventDefault();
      };
      this.onClose = () => this.dialog.close();
      this.restoreFocus = () => {
        if (this.phone.isConnected) this.phone.focus({ preventScroll: true });
      };
      this.onKeydown = event => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), summary, [tabindex="0"]')].filter(control => !control.hidden && control.getClientRects().length);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if ((!event.shiftKey && document.activeElement === last) || (event.shiftKey && document.activeElement === first)) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        }
      };
      this.phone.addEventListener('click', this.onCall);
      this.closeButton.addEventListener('click', this.onClose);
      this.dialog.addEventListener('close', this.restoreFocus);
      this.dialog.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.phone?.removeEventListener('click', this.onCall);
      this.closeButton?.removeEventListener('click', this.onClose);
      this.dialog?.removeEventListener('close', this.restoreFocus);
      this.dialog?.removeEventListener('keydown', this.onKeydown);
    }
  }

  customElements.define('sac-support-hours', SacSupportHours);
})();
